/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).ready(function () {
    $("[data-bundle-item]").click(function(){
      const bundle = $(this).data('bundle-item');
      const title = $(this).data('bundle-title');
      const redirect = $(this).data('redirect') ? true : false;
      try{
        window.addBundleItemsToCart(bundle,title, false, redirect)
        this.dataset.loading = 'true';
        }catch(e){
            console.log(e);
            delete this.dataset.loading;
            this.dataset.loaded = 'true';
        }
    })
    $("[data-add]").click(function(){
        const id = $(this).data('add');
        const quantity = 1

        
        try{
          this.dataset.loading = 'true';
                fetch('/cart/add.js', {
                 method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({id, quantity}),
                }).then(response => {
                    if (response.ok) {
                        let currentCount = $('.Header__CartCount').text();
                        currentCount = Number(currentCount) + 1;
                        $('.Header__CartCount').text(currentCount)
                         delete this.dataset.loading;
                         this.dataset.loaded = 'true';
                    }
                }).catch(error => {
                    console.error('Error:', error);
                });
          }catch(e){
              console.log(e);
              delete this.dataset.loading;
              this.dataset.loaded = 'true';
          }
      })
    window.addEventListener('skio::added-to-cart', (event) => {
        let currentCount = $('.Header__CartCount').text();
        currentCount = Number(currentCount) + 2;
        $('.Header__CartCount').text(currentCount)
         $('[data-bundle-item][data-loading]').removeAttr('data-loading').attr('data-loaded', "true")
    });


   let bundleCarousel = new Swiper('.bundle-grid', {
                autoplay: {
                    delay: 5000,
                  },
                  slidesPerView: 1.2,
                 breakpoints: {
                   1008: {
                     slidesPerView:3
                   }
                 }
              });

    var startingBackground = "url(\"" + $(".mega-linklist-parent--active").data('megaBackground') + "\")";
    if (startingBackground !== undefined) {
      	
        $(".mega-linklist-parent--active").parents(".MegaMenu").css("background-image", startingBackground);
    }

    $(".mega-linklist-parent").mouseover(function (e) {
        $(".mega-linklist-parent").removeClass("mega-linklist-parent--active");
        $(this).addClass("mega-linklist-parent--active");
        $(".mega-linklist").removeClass("mega-linklist--active")
        $(this).children(".mega-linklist").addClass("mega-linklist--active")
        if ($(this).data("megaBackground") !== undefined) {
            var megaBackground = "url(\"" + $(this).data("megaBackground") + "\")"
            $(this).parents(".MegaMenu").css("background-image", megaBackground);
        }

    });
   
   
     if($('body').hasClass('page-library')){
        let searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has('id')){
        let param = decodeURIComponent(searchParams.get('id'));
     
          param = param.replace(/\s/g, "-");
          const libraryURL = `/blogs/library-of-resources/tagged/lib-${param}?view=library`;
          $.get(libraryURL, function (res) {
              //set title 
              let handle = param.toLowerCase().replace(/ /g,'-');
              console.log(handle)
              let heading = document.querySelector(`[data-title="${handle}"]`)
              if(heading){
                  heading.classList.add('active');
              }
              $('.ArticleListWrapper').html(res);
              $('.ArticleListWrapper').removeClass('hidden');
          });
      }else{
           $('.ArticleListWrapper').removeClass('hidden');
      }
    }
    
    /* Library of Resources */
    $('.LibraryPage').on('change', '#sel_type', function () {
        const type = this.value;
        if (type == 'all') {
            location.reload();
            return;
        }
        $.get('/pages/library-of-resources?view=library-raw&type=' + type, function (res) {
            $('.ArticleListWrapper').html(res);
        });
    });
});

(function () {
  var hero = document.querySelector('.pwr-biocidin-hero');
  if (!hero) {
    return;
  }

  var iframe = hero.querySelector('iframe');
  var reveal = function () {
    hero.classList.add('is-ready');
  };

  window.setTimeout(reveal, 1200);

  if (iframe) {
    iframe.addEventListener('load', function () {
      window.setTimeout(reveal, 450);
    });
  }
})();


/* AMBAUM'S CUSTOM SCRIPTS */
// quick order form search
var $search_input = $('[quick-order-search-input]');
var $search_cta = $('[quick-order-search-submit]');

// quick order form
var CART_DATA = JSON.parse($('[data-cart-json]').text());
var $quick_order_form = $('[quick-order-form]');
var $quantity_input_toggle = $('[data-action]');
var $quantity_input_fields = $quick_order_form.find('[data-quantity-for]');
var $add_cta = $('[quick-order-cta]');
var $add_cta_loading_icon = $('[quick-order-loading-icon]');
var $add_cta_text = $('[quick-order-cta-text]');
var $in_cart_text = $('[in-cart-text]');
var $in_cart_text_link = $in_cart_text.find('a:first');

$(document).ready(function () {
    if (CART_DATA.item_count > 0) {
        populate_in_cart_quantity_fields();
    }
    track_search();
    track_quantity_change();
    track_cta_click();
    //track_to_cart_click();
});

// track search
function track_search() {
    $search_cta.on('click', function (e) {
        var search_keyword = $search_input.val().toLowerCase();
        $('.product-item').addClass('d-none');
        show_results(search_keyword);
    });
}
function show_results(search_keyword) {
    $('.product-item').each(function () {
        var product_title = $(this).find('[data-product-title]').text().toLocaleLowerCase();
        if (!product_title.includes(search_keyword)) {
            return;
        }
        $(this).removeClass('d-none');
    });
}
function build_graphql_query(search_keyword, cursor) {
    return `{
      collectionByHandle(handle: "{{ collection.handle }}") {
        products(first: 25 ${cursor}) {
          edges {
            cursor
            node {
              title
              onlineStoreUrl
              images(first: 1) {
                edges {
                  node {
                    altText
                    transformedSrc(maxWidth: 180)
                  }
                }
              }
              variants(first: 1) {
                edges {
                  node {
                    id
                    priceV2{
                      amount
                    }
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
          }
        }
      }
    }`;
}
function graphql_ajax_call(search_keyword, query, in_cart) {
    $.ajax({
        url: "https://bio-botanical-research.myshopify.com/api/2021-01/graphql",
        type: 'post',
        data: query,
        beforeSend: function (xhr) {
            xhr.setRequestHeader("Accept", "application/json");
            xhr.setRequestHeader("Content-Type", "application/graphql");
            xhr.setRequestHeader("X-Shopify-Storefront-Access-Token", "d11597aa46d8a054bc541b1c62d05899");
        },
        success: function (response) {
            var collection_data = response.data.collectionByHandle;
            var edges = collection_data.products.edges;
            for (const edge of edges) {
                var product = edge.node;

                // if product doesn't contain keyword or not available online store
                if (!product.title.toLowerCase().includes(search_keyword) || product.onlineStoreUrl == 'null') {
                    continue;
                }
                var quick_order_item_html = generate_item_html(product, in_cart);
                $quick_order_form.append(quick_order_item_html);
            }

            // if we're at the last page
            if (collection_data.products.pageInfo.hasNextPage == false) {
                return;
            }
            // else continue querying till no more
            var last_cursor = `, after: "${edges[edges.length - 1].cursor}"`;
            var query = build_graphql_query(search_keyword, last_cursor);
            graphql_ajax_call(search_keyword, query);
        },
        error: function (request, status, error) {
            console.log(request);
            console.log(status);
            console.log(error);
            alert("Something went wrong, please try again later!");
        }
    });
}
function generate_item_html(product, in_cart) {
    var image = product.images.edges[0].node;
    var variant = product.variants.edges[0].node;
    var variant_id = format_graphql_id(variant.id);
    var data = {
        product_url: product.onlineStoreUrl,
        product_image_src: image.transformedSrc,
        product_image_alt: (image.altText.length > 0) ? image.altText : product.title,
        product_title: product.title,
        product_price: '$' + variant.priceV2.amount,
        variant_id: variant_id,
        variant_quantity: (in_cart.hasOwnProperty(variant_id)) ? in_cart[variant_id] : '0'
    };
    var item_html = replace_me($quick_order_item_template, data);
    return item_html;
}

// populate quanitty on page
function populate_in_cart_quantity_fields() {
    var line_items = CART_DATA.items;
    var in_cart = get_in_cart_data(line_items);
    var visible = (CART_DATA.item_count > 0) ? true : false;
    var cta_text = (visible) ? 'Update Quantities' : 'Add to cart';

    $add_cta_text.text(cta_text);
    $add_cta_loading_icon.toggleClass('d-none', visible);
    $in_cart_text.toggleClass('d-none', !visible);

    $quantity_input_fields.each(function () {
        var variant_id = $(this).attr('data-quantity-for');
        if (in_cart.hasOwnProperty(variant_id)) {
            $(this).val(in_cart[variant_id]);
        }
    });
}

// track quantity change
function track_quantity_change() {
    $(document).on('click', '.quick-order-form .QuantitySelector__Button', function () {
        var $wrapper = $(this).closest('.QuantitySelector');
        var action_type = $(this).attr('data-action');
        var $quantity_input = $wrapper.find('.QuantitySelector__CurrentQuantity');
        var current_quantity = clean_quantity_input($quantity_input.val());

        var new_quantity = (action_type == 'decrease-quantity') ? current_quantity - 1 : current_quantity + 1;
        new_quantity = (new_quantity < 0) ? 0 : new_quantity;
        $quantity_input.val(new_quantity);
    });
}

// track cta click
async function track_cta_click() {
    $add_cta.on('click', async function (e) {
        e.preventDefault();
        var updates = await get_updates();

        if (!Object.keys(updates).length) {
            return;
        }
        $(this).prop('disabled', true);
        $add_cta_loading_icon.removeClass('d-none');
        console.log(updates);
        ajax_update_cart(updates);
    });
}

async function get_updates() {
    let updates = {};
    let updates_data = [];
    let attributes = {};
    let promos = [];
    let xProductsInCart = [];
    let appliedPromos = [];

    for (const input of $quantity_input_fields) {
        const quantity = clean_quantity_input($(input).val());
        const id = input.dataset.quantityFor;
        
        updates_data.push({ id, quantity });
        
        if (quantity != 0){
            attributes[id] = parseInt(input.dataset.altVariant);
        }
        if (input.dataset.promo) {
            promos.push(input.dataset.promo);
            xProductsInCart.push(quantity);
        }
    };


    updates_data = updates_data.reduce((results, { id, quantity }) => {
        results[id] = quantity;
        return results;
    }, {});

    updates.updates = updates_data;
    updates.attributes = attributes;
    
    if (promos.length <= 0) {
        return updates;
    }

    for (let i = 0; i < promos.length; i++) {

        const promo = promos[i];
        if (appliedPromos.includes(promo)){
            continue;
        }

        const [promoHandle, minQuantity] = promo.split('::').slice(-2);
        const xInCart = xProductsInCart[i]
        if (xInCart < minQuantity) {
            continue;
        }
        appliedPromos.push(promo);

        const promoProduct = await getPromoProduct(promoHandle);
        if (!promoProduct) {
            continue;
        }

        const promoTag = promoProduct.tags.find(tag => tag.indexOf('promo-item::') === 0);
        if (!promoTag) {
            continue;
        }
        
        const promoVariantId = promoProduct.variants[0].id;
        const promoQuantity = promoTag.split('::').pop();
        const promoCartQuantity = updates_data[promoVariantId] ? updates_data[promoVariantId] : 0;
        const remainingAvailable = promoQuantity - promoCartQuantity;

        if (remainingAvailable > 0) {
            updates_data[promoVariantId] = promoQuantity;
        }
    }

    updates.updates = updates_data;
    return updates;
}

async function getPromoProduct(handle) {
    return fetch(`/products/${handle}.js`).then(response => response.json());
}

function ajax_update_cart(updates) {
    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: updates,
        dataType: 'json',
        success: function (result) {
            console.log(result);
            CART_DATA = result;
            populate_in_cart_quantity_fields();
            var cart_quantity = result.item_count;
            $('.Header__CartCount').text(cart_quantity);
        },
        error: function (request, status, error) {
            console.log(request);
            console.log(status);
            console.log(error);
            alert("Something went wrong, please try again later!");
        },
        complete: function () {
            setTimeout(function () {
                $add_cta.prop('disabled', false);
                $add_cta_loading_icon.addClass('d-none');
            }, 6000);
        }
    });
}

// track to cart click
function track_to_cart_click() {
    $in_cart_text_link.click(function (e) {
        e.preventDefault();
        var target_url = $(this).attr('href');
        if (!target_url.includes('cart')) {
            return;
        }
        $('#cart-drawer-toggle')[0].click();
    });
}

// helpers
function clean_quantity_input(value) {
    return parseInt(value.replace(/[^0-9]/g, ''))
}
function format_graphql_id(id) {
    return window.atob(id).split('/').pop();;
}
function replace_me(template, data) {
    const pattern = /{\s*(\w+?)\s*}/g; // {property}
    return template.replace(pattern, (_, token) => data[token] || '');
}
function get_in_cart_data(line_items) {
    var in_cart = {};
    for (var i = 0; i < line_items.length; i++) {
        var item = line_items[i];
        in_cart[item.variant_id.toString()] = item.quantity;
        in_cart[item.variant_id] = item.quantity;
    }
    return in_cart;
}
/* END AMBAUM'S CUSTOM SCRIPTS */
/* PRO ACADEMY MENU */


/* ACADEMY PRO MENU */
$(document).ready(function() {
    $( "[data-academy-mobile-toggle]" ).click(function() {
       $('.mobile-academy-pro-menu').toggleClass('open');
    });

    //REVIEW CAROUSEL 

    // let reviews = new Swiper('.dynamic-reviews', {
    //     autoplay: {
    //         delay: 5000,
    //       },
    //       slidesPerView: 1
    //   });
});


/*Fixing product image list being hard to scroll on iOS13 https://support.maestrooo.com/article/209-fixing-product-image-list-being-hard-to-scroll-on-ios13*/


(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();